import BaseInfo from '@/model/modules/BaseInfo'

export default class CourierInfo extends BaseInfo {
  companyId: number = 0
  courierName: string = ''
  onlyKey: string = ''
}
